import { Col, Row, Tabs } from "antd"
import React, { useState } from "react"
import PageHeader from "../../../components/Elements/PageHeader"
import { ShoppingCartOutlined } from "@ant-design/icons"
import ActiveOrders from "../../../components/Cutter/Orders/ActiveOrders"
import DoneCutterOrders from "../../../components/Cutter/Orders/DoneCutterOrders"

export default function CutterOrders() {
  const [activeKey, setActiveKey] = useState(1)
  const tabItems = [
    {
      label: "Active Orders",
      key: 1,
      children: <ActiveOrders activeKey={activeKey} />,
    },
    {
      label: "Done Orders",
      key: 2,
      children: <DoneCutterOrders activeKey={activeKey} />,
    },
  ]

  //handle active key
  const handleActiveKey = (value) => {
    setActiveKey(value)
  }
  return (
    <div>
      <Row>
        <Col span={24}>
          <PageHeader icon={<ShoppingCartOutlined />} text="Cutter Orders" />
        </Col>
        <Col span={24}>
          <Tabs defaultActiveKey="1" items={tabItems} onChange={handleActiveKey} />
        </Col>
      </Row>
    </div>
  )
}
